import referee from "./referee";

export const REFEREE_NAMESPACE = "referee";

export default referee;
